import { useMemo } from 'react';

export interface IPromptCard {
  id: string;
  title: string;
  description: string;
  category: string;
  model: string;
  type: 'system' | 'user';
  persona?: string;
  subproduct?: string;
  tags?: string[];
  authorEmail?: string;
}

/**
 * Hook to transform raw prompt data into ChatBot-ready prompt cards
 * @param rawPrompts - Array of raw prompt objects from API
 * @param userEmail - Current user's email for determining prompt ownership
 * @returns Array of transformed IPromptCard objects
 */
export function useChatBotPrompts(
  rawPrompts?: any[],
  userEmail?: string,
): IPromptCard[] {
  return useMemo(() => {
    if (!rawPrompts || !Array.isArray(rawPrompts)) {
      return [];
    }

    return rawPrompts.map((p: any) => {
      const promptAuthor = (p.authoremail || '').toLowerCase();
      const currentUser = (userEmail || '').toLowerCase();
      const isUserPrompt = !!promptAuthor && promptAuthor === currentUser;

      return {
        id: p.id,
        title: p.promptkey || p.id,
        description: p.promptdetail || '',
        category: p.subproduct || p.product || 'General',
        model: '',
        type: (isUserPrompt ? 'user' : 'system') as 'user' | 'system',
        persona: p.persona?.[0],
        subproduct: p.subproduct,
        tags: p.tags,
        authorEmail: p.authoremail,
      };
    });
  }, [rawPrompts, userEmail]);
}
